<!-- HEADING PART -->
<p-card>
  <div class="grid">

    <div class="col-12 md:col-12 lg:col-12 breadcrumbrightmenu">
      <div *ngIf="userRole != 0" class="text-end p-0 border-round-sm font-bold">
        <p-button *ngIf="limitedAccess == 'N'  && userRole == 1" (click)="onAddLocationClick()"
          styleClass="customAdd p-button-sm p-button-raised mr-4" icon="fa fa-plus" pTooltip="Add Location"
          tooltipPosition="left"></p-button>

        <p-button *ngIf="userRole == 1 && limitedAccess == 'N'" type="button"
          class="btn btn-primary-outline btn-sm mr-4"
          pTooltip="Download Excel Template and enter Location data in Excel format" id="complexcelformat"
          (click)="downloadformate=true" tooltipPosition="bottom">
          Download Excel Format
        </p-button>

        <p-button *ngIf="userRole == 1 && limitedAccess == 'N' " type="button"
          class="btn btn-primary-outline btn-sm mr-4" pTooltip="Upload Location Data" id="complexcelformat"
          (click)="onUploadModalClick()" tooltipPosition="bottom">
          Upload Location Data
        </p-button>
        <button class="fa fa-question helpicon" pTooltip="Help"
          (click)="PagehelpmodalService.openhelpmodal(ref,dialogService,'Help','2')" tooltipPosition="bottom"
          aria-hidden="true"></button>
      </div>
    </div>
  </div>

  <div *ngIf="userRole == 0" class="formgrid grid">
    <div class="field col-12"
      style="display: flex; justify-content: center; align-items: center; gap: 10px; text-align: center;">
      <label for="group" style="font-weight: bold;">Organisation</label>
      <p-dropdown [options]="organisationList" [filter]="true" appendTo="body" optionLabel="name" optionValue="orgid"
        formControlName="group" id="group" [(ngModel)]="selectedOrgId" (onChange)="onOrgChange($event.value)"
        name="group" style="width: 40%; min-width: 250px;" [showClear]="true">
      </p-dropdown>
    </div>
  </div>

  <div class=" mr-0 tablehiegt">
    <p-table #dt [value]="tableData" [rows]="rowsize" [scrollable]="true" scrollDirection="horizontal"
      scrollHeight="{{commonScrollHeight}}" [customSort]="true" (sortFunction)="this.utilityservice.customSort($event)"
      [globalFilterFields]="searchcolumns" [resizableColumns]="true" columnResizeMode="expand"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      (onPage)="handlePageChange($event)" [rowsPerPageOptions]="paginatorArray" dataKey="id" [rowHover]="true"
      [showCurrentPageReport]="true" paginatorLocale="fa-IR" [paginator]="tableData.length>0" responsiveLayout="scroll"
      [sortField]="sortfield" [sortOrder]="sortorder" columnResizeMode="expand">
      <!-- search -->
      <ng-template pTemplate="caption">
        <div class="grid table-header">
          <div class="col-12 md:col-10 sm:col-12 lg:col-10">
            <span class=" p-input-icon-lft">
              <i icon="pi pi-search"></i>
              <input class="form-control" pInputText type="text" id="tablesearch"
                (input)="dt.filterGlobal($any($event.target).value , 'contains'); searchTerm = $any($event.target).value;" placeholder="Search in Location"
                class="tablesearch" pTooltip="Enter Search Criteria" tooltipPosition="top" />
            </span>
          </div>
          <div class="col-12 lg:col-2 md:col-2 sm:col-12 ">
            <div class="iconexcel" pTooltip="Download Data" tooltipPosition="bottom" (click)="exceldownloadModal=true">
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 5px !important;" class="tableaction">Action</th>
          <ng-container *ngFor="let col of _selectedColumns">
            <th [pSortableColumn]="col.field" *ngIf="col.isChecked" pResizableColumn>
              {{col.header}}<p-sortIcon [field]="col.field"></p-sortIcon>
              <p-columnFilter type="text" [field]="col.field" *ngIf="col.filter" display="menu"></p-columnFilter>

            </th>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data>
        <tr>
          <td style="width: 5px !important;">
            <div style="display: flex; gap: 0px;">
              <span class="actionItm" pTooltip="Modify" tooltipPosition="left"> <i class="fa fa-edit"
                  (click)="show('Modify Location',data)"></i></span>
            </div>
          </td>
          <ng-container *ngFor="let col of _selectedColumns">
            <!-- <td *ngIf="col.isChecked" [style.width]="col.width" [class]="col.class">
              <span *ngIf="col.field!=='activeflag'" pTooltip=" {{data[col.field] }}"> {{data[col.field] }}</span>
              <span *ngIf="col.field=='activeflag'">
                <i *ngIf="data[col.field]=== 'Active'" pTooltip="Active" tooltipPosition="left" class="fa fa-flag"
                  aria-hidden="true" style="color: green;"></i>
                <i *ngIf="data[col.field]!== 'Active'" pTooltip="Inactive" tooltipPosition="left" class="fa fa-flag"
                  aria-hidden="true" style="color: red;"></i>
              </span>
            </td> -->
            <td *ngIf="col.isChecked" [style.width]="col.width" [class]="col.class">
              <span *ngIf="col.field !== 'activeflag'" pTooltip=" {{data[col.field]}}"
                [innerHTML]="highlight(data[col.field],searchTerm)"></span>
              <span *ngIf="col.field=='activeflag'">
                <i *ngIf="data[col.field]=== 'Active'" pTooltip="Active" tooltipPosition="left" class="fa fa-flag"
                  aria-hidden="true" style="color: green;"></i>
                <i *ngIf="data[col.field]!== 'Active'" pTooltip="Inactive" tooltipPosition="left" class="fa fa-flag"
                  aria-hidden="true" style="color: red;"></i>
              </span>
            </td>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="10" class="datanotfound">
            No data available
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-card>


<!-- download excel formate for bulkupload -->
<p-dialog header="Download Excel Format" [(visible)]="downloadformate" [modal]="true" [baseZIndex]="10000"
  [draggable]="true" [resizable]="false" position="center" [style]="{width: '70%', height: '30%'}">
  <div class="dialog-content-min-excel" style=" text-align: center !important;">
    <div class="card">
      <p>{{templatedownloadtext}}</p>
    </div>
  </div>
  <div class="custom-dialog-footer">
    <p-button class="m-1 w-full" label="Close" styleClass="customeclose" (click)="downloadformate=false"></p-button>
    <p-button class="m-1 w-full" label="Download" styleClass="customesave" (click)="excelUploadFormat()"></p-button>
  </div>
</p-dialog>

<p-dialog header="Excel Download" [(visible)]="exceldownloadModal" [modal]="true" [baseZIndex]="10000"
  [draggable]="true" [resizable]="false" position="center">
  <div class="dialog-content-min-excel" style=" text-align: center !important;">
    <div class="card">
      <p>{{excel_paragraph}}</p>
    </div>
  </div>

  <div class="custom-dialog-footer">
    <p-button class="m-1 w-full" label="Close" styleClass="customeclose" (click)="exceldownloadModal=false"></p-button>
    <p-button class="m-1 w-full" label="Download" styleClass="customesave" (click)="excelDownload()"></p-button>
  </div>
</p-dialog>